// extracted by mini-css-extract-plugin
export default {"followbutton":"FollowingOrder_followbutton__zZGzF"};